import { useCallback, useRef, useState } from 'react';

type ConfirmState = {
  message: string;
  resolve: (value: boolean) => void;
};

export function useConfirmDialog() {
  const [state, setState] = useState<ConfirmState | null>(null);
  const resolverRef = useRef<((value: boolean) => void) | null>(null);

  const confirm = useCallback((message: string) => {
    return new Promise<boolean>((resolve) => {
      resolverRef.current = resolve;
      setState({ message, resolve });
    });
  }, []);

  const handleConfirm = useCallback(() => {
    resolverRef.current?.(true);
    resolverRef.current = null;
    setState(null);
  }, []);

  const handleCancel = useCallback(() => {
    resolverRef.current?.(false);
    resolverRef.current = null;
    setState(null);
  }, []);

  return {
    confirm,
    confirmOpen: state !== null,
    confirmMessage: state?.message ?? '',
    handleConfirm,
    handleCancel,
  };
}
